export const links = [
    {
        id: 1,
        text: 'Página inicial ',
        url: '#home',
    },
    {
        id: 2,
        text: 'Portal do contribuinte',
        url: '#portal',
    },
    {
        id: 3,
        text: 'Sistema',
        url: '#sistemas',
    },
    {
        id: 5,
        text: `Contato`,
        url: '#contatos',
    },
]